// src/context/SearchContext.js

import React, { createContext, useState, useContext } from 'react';

const SearchContext = createContext();

export function SearchProvider({ children }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchField, setSearchField] = useState('title');

  return (
    <SearchContext.Provider value={{ searchQuery, setSearchQuery, searchField, setSearchField }}>
      {children}
    </SearchContext.Provider>
  );
}

export function useSearch() {
  return useContext(SearchContext);
}
